import React from 'react'
import PropTypes from 'prop-types'

import Box from '../Box'
import LoadingBubbles from '../LoadingBubbles'
import Text from '../Text'

import BlankState from './BlankState'
import FilterHeader from './FilterHeader'
import Filters from './Filters'
import Footer from './Footer'
import FooterRight from './FooterRight'
import HeaderLink from './HeaderLink'
import ListItem from './ListItem'
import LoadMoreFooter from './LoadMoreFooter'
import ScrollableSection from './ScrollableSection'

const DashboardModule = (props) => {
  const { 
    boxProps,
    children,
    contentBoxProps,
    customHeader,
    editing,
    headerRight,
    loading,
    title,
  } = props

  return (
    <Box
      backgroundColor="white"
      border="1px solid"
      borderColor="lineColor"
      borderTopLeftRadius={editing ? 0 : 5}
      borderTopRightRadius={editing ? 0 : 5}
      borderBottomLeftRadius={5}
      borderBottomRightRadius={5}
      flexDirection="column"
      marginBottom="large"
      width="100%"
      {...boxProps}
    >
      {/* Custom Header */}
      {customHeader}
      {/* End Custom Header */}

      {/* Header */}
      {!customHeader && !editing && (
        <Box
          alignItems="center"
          borderBottom={children ? '1px solid' : 'none'}
          borderColor="lineColor"
          padding="large"
          width="auto"
        >
          <Text color="bodyFontLightColor" letterSpacing="0.5px" fontSize="small" width="auto">
            {loading ? <LoadingBubbles /> : title}
          </Text>

          {!loading && (
            <Box alignItems="center" justifyContent="flex-end" marginLeft="auto" width="auto">
              {headerRight}
            </Box>
          )}
        </Box>
      )}
      {/* End Header */}

      {/* Content */}
      <Box flexDirection={['column', 'row']} {...contentBoxProps}>
        {children}
      </Box>
      {/* End Content */}
    </Box>
  )
}

DashboardModule.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
  contentBoxProps: PropTypes.object,
  customHeader: PropTypes.node,
  editing: PropTypes.bool,
  headerRight: PropTypes.node,
  loading: PropTypes.bool,
  title: PropTypes.string,
}

DashboardModule.BlankState = BlankState
DashboardModule.FilterHeader = FilterHeader
DashboardModule.Filters = Filters
DashboardModule.Footer = Footer
DashboardModule.FooterRight = FooterRight
DashboardModule.Link = HeaderLink
DashboardModule.ListItem = ListItem
DashboardModule.LoadMoreFooter = LoadMoreFooter
DashboardModule.ScrollableSection = ScrollableSection

export default DashboardModule
